import { FEATURE_FLAGS } from "../flags/index.js";

const originalConsoleLog = console.log;

let posthogInstance = null;

export const setPostHogInstance = (posthog) => {
  posthogInstance = posthog;

  try {
    applyConsoleOverrideBasedOnFlag();

    if (
      posthogInstance &&
      typeof posthogInstance.onFeatureFlags === "function"
    ) {
      posthogInstance.onFeatureFlags(() => {
        applyConsoleOverrideBasedOnFlag();
      });
    }
  } catch {
    restoreConsoleLog();
  }
};

const isConsoleLoggingEnabled = () => {
  if (!posthogInstance) {
    return true;
  }

  try {
    return posthogInstance.isFeatureEnabled(FEATURE_FLAGS.CONSOLE_LOGGING);
  } catch (error) {
    return true;
  }
};

const overriddenConsoleLog = (..._args) => {};

const applyConsoleOverrideBasedOnFlag = () => {
  if (isConsoleLoggingEnabled()) {
    restoreConsoleLog();
  } else {
    console.log = overriddenConsoleLog;
  }
};

export const initializeConsoleOverride = () => {
  restoreConsoleLog();
};

export const restoreConsoleLog = () => {
  console.log = originalConsoleLog;
};

export { originalConsoleLog };
